const outdated = document.querySelector('.js-outdated');
const close = document.querySelector('.js-outdated-close');

// shift body if alert is shown.
if (window.getComputedStyle(outdated).getPropertyValue("display") === 'block') {
    document.body.style.marginTop = `${outdated.offsetHeight}px`;
}

// close button
close.onmousedown = function() {
    outdated.style.display = 'none';
    document.body.style.marginTop = '';
    return false;
};
